export const AutomatedOnboardingRoutes = [
    {
        "url": '/automated-onboarding',
        "name": "appLayout.harriSH.automatedOnboarding",
        "type": "frontend",
        "abstract": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-automation/automated-onboarding.downgrade.module");
                }
            },
        ],
        "onEnter": [() => {
            }],
    },
    {
        "url": '/offer-automations',
        "name": "appLayout.harriSH.automatedOnboarding.offerAutomations",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "offerLetterAutomationContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["automated-onboarding"]
        },
        "route_dependencies": [],
        "onEnter": [() => {
            }],
    },
    {
        "url": '/manage-offer-automation?ruleId',
        "name": "appLayout.harriSH.automatedOnboarding.manageOfferAutomation",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "offerLetterAutomationRuleWizardContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["automated-onboarding"]
        },
        "route_dependencies": [],
        "onEnter": [() => {
            }],
    }
];
//# sourceMappingURL=automated-onboarding.routes.js.map